import React, { useState } from 'react';
import { useChat } from '../contexts/ChatContext';

function Sidebar() {
  const { 
    chats, 
    currentChatId, 
    setCurrentChatId, 
    createNewChat, 
    deleteChat,
    renameChat 
  } = useChat();
  
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const startRename = (chat) => {
    setEditingId(chat.id);
    setEditValue(chat.name);
  };

  const saveRename = (id) => {
    if (editValue.trim()) {
      renameChat(id, editValue.trim());
    }
    setEditingId(null);
  };

  const handleDelete = (e, id) => {
    e.stopPropagation();
    if (window.confirm('Delete this chat?')) {
      deleteChat(id);
    }
  };

  const chatList = Object.values(chats)
    .filter(chat => {
      if (!searchQuery) return true;
      return chat.name.toLowerCase().includes(searchQuery.toLowerCase());
    })
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>🖤 Baba AI</h2>
        <button className="new-chat-btn" onClick={() => createNewChat()}>
          + New
        </button>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search chats..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="chat-list">
        {chatList.map(chat => (
          <div
            key={chat.id}
            className={`chat-item ${chat.id === currentChatId ? 'active' : ''}`}
            onClick={() => setCurrentChatId(chat.id)}
          >
            {editingId === chat.id ? (
              <input
                type="text"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onBlur={() => saveRename(chat.id)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') saveRename(chat.id);
                }}
                autoFocus
                className="chat-name-input"
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <>
                <div className="chat-info">
                  <div className="chat-name">{chat.name}</div>
                  <div className="chat-preview">
                    {chat.messages.length > 0
                      ? chat.messages[chat.messages.length - 1].content.substring(0, 50) + '...'
                      : 'No messages yet'}
                  </div>
                </div>
                <div className="chat-actions">
                  <button
                    className="chat-action-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      startRename(chat);
                    }}
                    title="Rename"
                  >
                    ✏️
                  </button>
                  <button
                    className="chat-action-btn"
                    onClick={(e) => handleDelete(e, chat.id)}
                    title="Delete"
                  >
                    🗑️
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="sidebar-footer">
        <div className="chat-count">
          {Object.keys(chats).length} chat{Object.keys(chats).length !== 1 ? 's' : ''}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
